module.exports = __webpack_public_path__ + "media/mine1.8028dcda.wav";